import { FormattedMessage } from 'react-intl';

const TIME_INTERVALS = [
    { interval: 31536000, messageId: 'time.years-ago' },
    { interval: 2592000, messageId: 'time.months-ago' },
    { interval: 86400, messageId: 'time.days-ago' },
    { interval: 3600, messageId: 'time.hours-ago' },
    { interval: 60, messageId: 'time.minutes-ago' },
    { interval: 1, messageId: 'time.seconds-ago' },
];

/** How long ago `date` was, in words. */
export default function TimeSinceDate({ date }: { date: Date | string }) {
    // Passed time between now and input date in seconds.
    const seconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);

    const { interval, messageId } = TIME_INTERVALS.find((unit) => {
        const unitsSinceDate = seconds / unit.interval;
        return unitsSinceDate >= 1;
    }) || { interval: 0, messageId: 'time.seconds-ago' };

    const calculatedPeriod = Math.floor(seconds / interval);
    return (
        <p className="text-fg-secondary text-xs">
            <FormattedMessage values={{ count: isNaN(calculatedPeriod) ? 0 : calculatedPeriod }} id={messageId} />
        </p>
    );
}
